import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	CustomerFullInfoContext,
	ICustomerFullInfoContext,
} from '../../../../../../../customerFullInfoState/customerFullInfoContext';

const Tips2Field: React.FC = () => {
	const { customerForFullInfo } = useContext<ICustomerFullInfoContext>(CustomerFullInfoContext);

	if (customerForFullInfo?.defaultTips[2]) {
		return (
			<FullInfoField
				label={customerForFullInfo.defaultTips[2].isDefault ? 'tips2DefaultLabel' : 'tips2Label'}
				value={customerForFullInfo.defaultTips[2].value}
			/>
		);
	}
	return <FullInfoField label="tips2Label" value={null} />;
};

export default Tips2Field;
